import React from 'react'

import { Sections, Wrappers } from '../styles'

const StudentsList = ({ students = [], ...rest }) => (
    <Sections.Student {...rest}>
        {students.map(student => (
            <Wrappers.Student key={student.key}>{student}</Wrappers.Student>
        ))}
    </Sections.Student>
)

const Students = ({ students = [], count = students?.length }) => {
    switch (count) {
        case 1:
        case 2:
            return (
                <StudentsList className="student-section" students={students} />
            )
        case 3:
        case 4:
            return (
                <>
                    <StudentsList
                        left
                        className="student-section-left"
                        students={students.slice(2)}
                    />
                    <StudentsList
                        right
                        className="student-section-right"
                        students={students.slice(0, 2)}
                    />
                </>
            )
        case 5:
        case 6:
            const fifthStudent = students[4]
            const rightStudents = students.slice(0, 2)
            if (fifthStudent) rightStudents.push(fifthStudent)

            const sixthStudent = students[5]
            const leftStudents = students.slice(2, 4)
            if (sixthStudent) leftStudents.push(sixthStudent)

            return (
                <>
                    <StudentsList
                        left
                        className="student-section-left"
                        students={leftStudents}
                    />
                    <StudentsList
                        right
                        className="student-section-right"
                        students={rightStudents}
                    />
                </>
            )

        default:
            return null
    }
}

export default Students
